/* eslint-disable import-x/no-default-export */
import { v4 as createUuid } from 'uuid';

import { createPlaceholderAvatarDataUri } from '../test/test-data';

const randomInt1To10 = () => Math.floor(Math.random() * 10) + 1;

export default () => {
  const hasAvatar = randomInt1To10() % 3 !== 0; // 66% chance of having an avatar
  if (!hasAvatar) {
    return null;
  }
  return {
    id: createUuid(),
    image128Url: createPlaceholderAvatarDataUri(),
  };
};
